<template>
    <div class="st-learning">

        <div id="feature-prod" class="hero-full" style="background-image:url('/images/st-learning/westchester-learning-center.jpg');">
            <div class="hero-text">
                <h1>Learning Center</h1>

                <p class="none">
                    Use this page to learn more about safety product basics and current standards in a simple way that's easy to understand and use in the field.
                </p>
            </div>
        </div>

        <div id="experts">

            <h3 id="experts-heading">PRODUCT TRAINING 101</h3>

            <VueSlickCarousel v-bind="settings">
                <div class="item">
                    <router-link :to="{ name: 'handprotectionexperts'}" >
                        <h4>HAND PROTECTION</h4>
                        <img src="/images/st-learning/img-experts-hand-protection.png" />
                    </router-link>
                </div>

                  
                <div class="item">
                    <router-link :to="{ name: 'hivisapparelexperts'}" > <h4>HI-VIS CLOTHING</h4>
                        <img src="/images/st-learning/img-experts-hi-vis-clothing.png" />
                    </router-link>
                </div>


                <div class="item">
                    <router-link :to="{ name: 'headprotectionexperts'}" > <h4>HEAD PROTECTION</h4>
                        <img src="/images/st-learning/img-experts-head-protection.png" />
                    </router-link>
                </div>


                <div class="item">
                    <router-link :to="{ name: 'earprotectionexperts'}" > <h4>HEARING PROTECTION</h4>
                        <img src="/images/st-learning/img-experts-hearing-protection.png" />
                    </router-link>
                </div>

                <div class="item">
                    <router-link :to="{ name: 'eyeprotectionexperts'}" > <h4>EYE PROTECTION</h4>
                        <img src="/images/st-learning/img-experts-eye-protection.png" />
                    </router-link>
                </div>

            </VueSlickCarousel>

        </div><!--END EXPERTS-->

        <h3 id="standards-heading">UNDERSTANDING THE STANDARDS</h3>

        <div id="training-standards">
            <div class="standards">
                <router-link :to="{ name: 'en388standards'}" >
                    <img src="/images/st-learning/img-updated-en388-standard-en.jpg" style="border:solid 1px #ccc;" />
                </router-link>
            </div>

            <div class="standards">
                <router-link :to="{ name: 'ansi105standards'}" >
                    <img src="/images/st-learning/img-updated-ansi-105-standard-en.jpg" style="border:solid 1px #ccc;" />
                </router-link>
            </div>

            <div class="standards">
                <router-link :to="{ name: 'ansi107standards'}" >
                    <img src="/images/st-learning/img-updated-ansi-107-standard-en.jpg" style="border:solid 1px #ccc;" />
                </router-link>
            </div>
        </div>

    </div>
</template>

<script>
    import VueSlickCarousel from "vue-slick-carousel";
    import "vue-slick-carousel/dist/vue-slick-carousel.css";
    import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
    export default {
        data() {
            return{
                settings: {
                    "centerMode": true,
                    "centerPadding": "20px",
                    "focusOnSelect": true,
                    "infinite": true,
                    "slidesToShow": 3,
                    "speed": 500,
                    "arrows":true,
                    "responsive": [
                        {
                        "breakpoint": 700,
                            "settings": {
                                "slidesToShow": 1,
                            }
                        }
                    ]
                }
            }
        },
        components: { VueSlickCarousel }
    };
</script>
